import React from 'react';
import css from './DocumentAndPaywallComponent.module.css';
import OutsideClickHandler from '../OutsideClickHandler/OutsideClickHandler';
import IconCollection from '../IconCollection/IconCollection';
import { documentDropdownData, testFolderData } from '../../util/circleHelper';
import { FOLDER_DOCUMENT_PAGE_SIZE } from '../../containers/MyGroupCommunityPage/MyGroupCommunityPage.duck';
import { FormattedMessage } from '../../util/reactIntl';

const DocumentAndPaywallComponent = props => {
  const {
    onClickDocumentDropdown,
    isDropdownDocument = false,
    onToggelAddDocument,
    onToggelAddFolder,
    params,
    allGroupFolders,
    fetchFolderRequest,
    fetchFolderError,
    onToggelFolderDocument,
    spaceDetail,
    totalDocumentCount,
    onFetchGroupDocumentFolder,
    onToggelSearchInGroup,
  } = props;

  const { is_private, is_member, policies } = spaceDetail ?? {};
  const { can_manage_space, can_view_space } = policies ?? {};
  const userHaveDocumnetViewPermissions = can_manage_space || can_view_space;
  const userHaveDocumnetUpadtePermissions = can_manage_space;

  //If a group is private, the [Documents] dropdown will only be visible to users that have joined the group.
  // if (is_private && !is_member) return null

  const documnetData = { id: 'addDocument', name: 'Add a Document' };
  const addFolderData = { id: 'addFolder', name: 'Add a Folder' };

  const documentDropdownData = [];

  if (
    userHaveDocumnetUpadtePermissions &&
    totalDocumentCount < process.env.REACT_APP_DOCUMENTS_LENGTH
  ) {
    documentDropdownData.push(documnetData);
  }

  if (
    userHaveDocumnetUpadtePermissions &&
    Array.isArray(allGroupFolders) &&
    allGroupFolders.length < process.env.REACT_APP_FOLDER_LENGTH
  ) {
    documentDropdownData.push(addFolderData);
  }

  const { id } = params || {};

  const handleDocumentDropdown = value => {
    if (value.id === 'addDocument') {
      onToggelAddDocument(true);
      onClickDocumentDropdown(false);
    } else if (value.id === 'addFolder') {
      onToggelAddFolder({ groupId: id });
      onClickDocumentDropdown(false);
    } else {
      const { groupId, folderId } = value;
      //fetch all folder documents
      onFetchGroupDocumentFolder({
        payload: {
          groupId,
          folderId,
          isActive: true,
          isDelete: false,
        },
        pageParams: {
          page: 1,
          perPage: FOLDER_DOCUMENT_PAGE_SIZE,
        },
      });
      onToggelFolderDocument(value);
      onClickDocumentDropdown(false);
    }
  };

  const showgropFolders = Array.isArray(allGroupFolders)
    ? allGroupFolders.filter(st =>
        userHaveDocumnetUpadtePermissions ? st : st.documentCount && st.documentCount > 0
      )
    : [];

  return (
    <div className={css.feedNav2}>
      {(userHaveDocumnetViewPermissions && showgropFolders.length) ||
      userHaveDocumnetUpadtePermissions ? (
        <div className={css.documentWrapper}>
          <OutsideClickHandler onOutsideClick={() => isDropdownDocument && onClickDocumentDropdown(false)}>
            <div onClick={() => onClickDocumentDropdown(!isDropdownDocument)}>
              Documents <IconCollection name="arrowDown" />
            </div>
            {isDropdownDocument ? (
              <div className={css.dropdownMenu}>
                <ul>
                  {documentDropdownData.map(option => (
                    <li key={option.id} onClick={() => handleDocumentDropdown(option)}>
                      + {option.name}
                    </li>
                  ))}
                  {showgropFolders.map(option => (
                    <li
                      key={option.folderId}
                      onClick={() => handleDocumentDropdown(option)}
                      style={{ paddingLeft: '20px' }}
                    >
                      {option.folderName}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </OutsideClickHandler>
        </div>
      ) : null}
      <div className={css.searchBar} onClick={() => onToggelSearchInGroup(true)}>
        <FormattedMessage id="SearchIngroup.searchBar" />
      </div>
    </div>
  );
};

export default DocumentAndPaywallComponent;
